import { render, staticRenderFns } from "./SwapLayoutModal.vue?vue&type=template&id=ebc280f0&scoped=true"
import script from "./SwapLayoutModal.vue?vue&type=script&lang=js"
export * from "./SwapLayoutModal.vue?vue&type=script&lang=js"
import style0 from "./SwapLayoutModal.vue?vue&type=style&index=0&id=ebc280f0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebc280f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ebc280f0')) {
      api.createRecord('ebc280f0', component.options)
    } else {
      api.reload('ebc280f0', component.options)
    }
    module.hot.accept("./SwapLayoutModal.vue?vue&type=template&id=ebc280f0&scoped=true", function () {
      api.rerender('ebc280f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/screens/SwapLayoutModal.vue"
export default component.exports